import React, { FC } from 'react';
import Styled from './styles';
import SideBar from '../side-bar';

type IProps = {};

const MainWrapper: FC<IProps> = ({ children }) => {
	return (
		<Styled.Wrapper>
			<SideBar width={window.innerWidth} />
			<Styled.Content width={window.innerWidth}>{children}</Styled.Content>
		</Styled.Wrapper>
	);
};

export default MainWrapper;
